import { render } from "./CategoryItem.vue?vue&type=template&id=61594028&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=61594028&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61594028"

export default script